import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { useGetIboOnboardingQuery } from "../../../services/ActionReports/ActionReportAPI";
import type { IboOnboardingResponse } from "../../../services/ActionReports/IboOnboardingAPI.types";
import { useWatchlistFetch } from "../hooks/useWatchlistFetch";

export const defaultIboOnboardingData = (): IboOnboardingResponse => {
  return {
    affAbo: "",
    period: 0,
    resultCount: 0,
    businessNature: "",
    results: [],
  };
};

export const useFetchIboOnboardingData = (period: string, skipRequest = false) => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetIboOnboardingQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: period,
      Locale: storedLocale(),
      BlockFilter: "true",
      BusinessNature: "1",
    },
    {
      skip: skipRequest,
    },
  );

  const { isLoading: isLoadingWatchlist } = useWatchlistFetch();

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [iboOnboardingData, setIboOnboardingData] = useState<IboOnboardingResponse>(defaultIboOnboardingData());

  useEffect(() => {
    // Only stop loading when both report data AND watchlist are ready
    setIsLoading(isFetching || isLoadingWatchlist);
    setErrorStatus(isError);

    if (!isFetching && !isError && payloadData) {
      setIboOnboardingData(payloadData);
    }
  }, [isFetching, period, isError, payloadData, isLoadingWatchlist]);

  return { isLoading, iboOnboardingData, errorStatus, refetch };
};
